import { parsePhoneNumber } from './phone-number.parser';

export const formatPhoneNumberForInput = (phone: string): string => {
  return parsePhoneNumber(phone).formattedForInput;
};

export const formatPhoneNumberInternational = (phone: string) => {
  return parsePhoneNumber(phone).formattedInternationalPlain;
};

// If US phone number - returns "national format" else returns "international formats"
export const formatPhoneNumberNationalForUS = (phone: string) => {
  const { country, formattedNational, formattedInternationalPlain } = parsePhoneNumber(phone);

  return country === 'US' ? formattedNational : formattedInternationalPlain;
};

export const formatPhoneNumberToE164 = (phone: string): string => {
  return parsePhoneNumber(phone).e164;
};

/**
 * Returns digits only for QR code / POS use.
 * - US: 10-digit national number (no country code) — required by Verifone/Gilbarco POS.
 * - Other countries (UA, MX, etc.): E.164 so we don't assume their POS expects national format.
 */
export const formatPhoneNumberToNationalDigits = (phone: string): string => {
  const parsed = parsePhoneNumber(phone);
  return parsed.country === 'US' ? parsed.nationalNumber : parsed.e164;
};
